import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Spin, message, Result } from 'antd';
import apiClient from '../services/axiosConfig';

const SlackCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState('processing');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const handleCallback = async () => {
      const params = new URLSearchParams(location.search);
      const code = params.get('code');
      const state = params.get('state');
      const error = params.get('error');

      if (error) {
        setStatus('error');
        setErrorMessage('Slack authorization was cancelled');
        
        // If in popup, close after delay
        if (window.opener) {
          setTimeout(() => {
            window.close();
          }, 3000);
        }
        return;
      }

      if (code && state) {
        try {
          const response = await apiClient.post('/integrations/slack/callback', {
            code,
            state
          });
          
          if (response.data.success) {
            setStatus('success');
            message.success('Slack connected successfully!');
            
            // If this is a popup window, close it
            if (window.opener) {
              setTimeout(() => {
                window.close();
              }, 1500);
            } else {
              // If not a popup, redirect to main app
              setTimeout(() => {
                navigate('/');
              }, 1500);
            }
          } else {
            throw new Error(response.data.error || 'Failed to complete Slack connection');
          }
          
        } catch (error) {
          console.error('Failed to complete Slack connection:', error);
          setStatus('error');
          setErrorMessage(error.response?.data?.error || error.message || 'Failed to complete Slack connection');
          
          // Close popup even on error
          if (window.opener) {
            setTimeout(() => {
              window.close();
            }, 3000);
          }
        }
      } else {
        setStatus('error');
        setErrorMessage('Invalid callback parameters');
      }
    };

    handleCallback();
  }, [location, navigate]);

  if (status === 'processing') {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        flexDirection: 'column',
        gap: '20px'
      }}>
        <Spin size="large" />
        <p style={{ fontSize: '16px' }}>Connecting to Slack...</p>
      </div>
    );
  }

  if (status === 'success') {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <Result
          status="success"
          title="Slack Connected Successfully!"
          subTitle="You can now close this window."
        />
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <Result
          status="error"
          title="Connection Failed"
          subTitle={errorMessage}
        />
      </div>
    );
  }

  return null;
};

export default SlackCallback;